import React from 'react';
import './Footer.css'

function Footer() {
    return (
        <div className='footer'>
            <p>© 2020 Airbnb clone! - this is a demo!</p>
           
        </div>
    )
}

export default Footer
